import { clearSection, dmpCommandFailureContextualizedType, dmpCommandSuccessContextualizedType }                      from "dmpconnectjsapp-base/actions";
import commands                                                                                                        from "dmpconnectjsapp-base/actions/config/commands";
import { accessModes, API_TYPES, apiSections }                                                                         from "dmpconnectjsapp-base/constants";
import { getApiType }                                                                                                  from "dmpconnectjsapp-base/helpers/accessors";
import { sessionExists }                                                                                               from "dmpconnectjsapp-base/helpers/checks/sessionExists";
import { authenticationTypes, getAccessRightsProps }                                                                   from "dmpconnectjsapp-base/rules/accessRights";
import { call, put, select, take }                                                                                     from "redux-saga/effects";
import { getAction, resetFindDocumentsParams, resetForceSecretConnexion, selectCertifiedIdentity, setDashboardInitOk } from "../actions";
import { expiredSessionErrorHandler }                                                                                  from "./errorHandlersSagas";
import { handleSetConfidentialityLevel, handleSetDmpAccessMode }                                                       from "./patientSagas";

export function * dashboardInit () {
  const apiType                                  = yield select(getApiType);
  const { accessRights: { authenticationType } } = yield select(getAccessRightsProps);
  // const regulationMode                           = yield select(({ dmpConnectPersistedAppConfiguration }) => getConfigurationValue('regulationMode', dmpConnectPersistedAppConfiguration));
  yield put(selectCertifiedIdentity(null));
  
  if (authenticationType === authenticationTypes.DIRECT) {
    yield put(getAction(
      commands.sessionExists,
      apiSections.SESSION_EXISTS_SECTION,
      null,
      {
        // synchronous: true,
        silentError: false
      }
    ));
    
    const result = yield take([
      dmpCommandSuccessContextualizedType(apiSections.SESSION_EXISTS_SECTION),
      dmpCommandFailureContextualizedType(apiSections.SESSION_EXISTS_SECTION)
    ]);
    const exists = yield call(sessionExists, result);
    if (!exists) {
      yield call(expiredSessionErrorHandler, result);
    }
  }
  
  if (
    (apiType !== API_TYPES.REST && authenticationType === authenticationTypes.DIRECT)
    || (apiType === API_TYPES.REST && authenticationType === authenticationTypes.AIR)
  ) {
    yield call(handleSetDmpAccessMode, { accessMode: accessModes.NormalAccess, accessModeReason: "" });
    
    yield take([
      dmpCommandSuccessContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION),
      dmpCommandFailureContextualizedType(apiSections.DMP_ACCESS_MODE_SECTION)
    ]);
  }
  
  yield put(clearSection(apiSections.FIND_DOCUMENTS_SECTION));
  yield put(clearSection(apiSections.CONFIDENTIALITY_LEVEL_SECTION));
  yield put(resetFindDocumentsParams());
  yield put(resetForceSecretConnexion());
  
  yield call(handleSetConfidentialityLevel, { ins: "all", confidentialityLevel: 0 });
  
  yield take([
    dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION),
    dmpCommandSuccessContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION_REST),
    dmpCommandFailureContextualizedType(apiSections.CONFIDENTIALITY_LEVEL_SECTION)
  ]);
  
  yield put(setDashboardInitOk());
}
